import Settings from '../domain/Settings';
import storage from '../utils/storage';

type CxenseProperties = {
	id: string
};

export function init() {
	window.cX = window.cX || {};
	window.cX.callQueue = window.cX.callQueue || [];

	if (Settings.getInstance().cxense?.includeLibrary) {
		_initializeLibrary();
	}

	window.cX.callQueue.push(['invoke', () => {
		const id = window.cX.getCxenseUserId();
		if (id) {
			storage.put('advert-cxense', id);
		}
	}]);

	if (Settings.getInstance().cxense?.pageViewEvent) {
		_sendPageViewEvent();
	}
}

function _initializeLibrary() {
	window.cX.options = {consent: true};
	window.cX.callQueue.push(['setConsent', {pv: true}]);
}

function _sendPageViewEvent() {
	window.cX.callQueue.push(['setEventAttributes', {
		origin: 'dpn-retargeting-Pixel',
		persistedQueryId: '362a54f75d61844e7d6387fed23f72322e15750d'
	}]);
	window.cX.callQueue.push(['setSiteId', '1353733223743909146']);
	window.cX.callQueue.push(['sendPageViewEvent']);
}

export function getCxenseProperties(): CxenseProperties | null {
	return {
		id: storage.get('advert-cxense')
	};
}